// Run grouping + schedule/hook headers (RunSection / ScheduleEditor)
// (WEB-8005). Composed by praxisStyles.ts at the section's original
// position — source order is part of the cascade.
export const praxisRunSections = `
/* Run grouping header — mirrors sidebar section heads so long run lists
   stay scannable (Today / Yesterday / This week / …). */
.pr-run-bucket-head {
  display: flex; align-items: center; gap: 8px;
  padding: 14px 0 6px;
  width: 100%;
  font-family: var(--pr-font-ui);
  font-size: 10.5px; font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--pr-ink-4);
  border-bottom: 1px solid var(--pr-hairline);
  background: transparent; border-left: none; border-right: none; border-top: none;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  transition: color 120ms ease;
}
.pr-run-bucket-head:hover { color: var(--pr-ink-3); }
.pr-run-bucket-chev {
  display: inline-flex; align-items: center; justify-content: center;
  transition: transform 140ms ease;
  color: var(--pr-ink-5);
}
.pr-run-bucket-chev.open { transform: rotate(90deg); }
.pr-run-bucket-label { flex: 1; }
.pr-run-bucket-count { font-weight: 500; text-transform: none; letter-spacing: 0; font-size: 11px; }

/* Schedule / hook header */
.pr-sched-header {
  display: flex; flex-direction: column;
  border: 1px solid var(--pr-hairline);
  border-radius: var(--pr-r-md);
  background: var(--pr-surface);
  box-shadow: var(--pr-shadow-sm);
  overflow: hidden;
}
.pr-sched-header-top {
  display: flex; align-items: center; gap: 6px;
  padding: 2px 6px;
  min-height: 28px;
  background: var(--pr-surface);
}
.pr-sched-header-top .pr-iconbtn { width: 24px; height: 24px; }
.pr-sched-header-top .pr-iconbtn svg { width: 14px; height: 14px; }
.pr-sched-trigger-tag {
  font-size: 10.5px; color: var(--pr-accent-ink);
  background: var(--pr-accent-soft);
  border: 1px solid var(--pr-accent-soft-2);
  padding: 1px 7px; border-radius: 999px;
  font-weight: 500;
  line-height: 1.5;
}
.pr-toggle {
  width: 28px; height: 16px; border-radius: 9px;
  background: var(--pr-surface-3); position: relative;
  cursor: pointer; transition: background 150ms ease;
  flex-shrink: 0;
  border: 1px solid var(--pr-border);
  padding: 0;
}
.pr-toggle .pr-tknob {
  position: absolute; top: 1px; left: 1px;
  width: 12px; height: 12px; border-radius: 50%;
  background: var(--pr-surface);
  box-shadow: 0 1px 2px rgba(0,0,0,0.2);
  transition: transform 150ms cubic-bezier(0.2, 0.8, 0.2, 1);
}
.pr-toggle.on { background: var(--pr-accent); border-color: var(--pr-accent); }
.pr-toggle.on .pr-tknob { transform: translateX(12px); }
.pr-retry-row { display: flex; justify-content: flex-end; }
`;
